import { CONTENT_TYPE_LABELS } from 'global/constants';

export const contentTypeLabel = (
  type: undefined | null | string
): undefined | string => {
  if (type === undefined || type === null) return undefined;
  const content_type = CONTENT_TYPE_LABELS.find(elem => {
    return elem.value === type;
  });
  if (content_type === undefined) return type;
  return content_type.label;
};
